import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
} from "reactstrap";

const Topup = ({ isOpen, toggle, formData, handleChange, handleSubmit }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        <strong style={{ color: "#000" }}>Top Up</strong>
      </ModalHeader>
      <ModalBody>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md="6">
              <FormGroup>
                <Label for="amount">Amount</Label>
                <Input
                className="form-control-alternative"
                  type="text"
                  name="amount"
                  id="amount"
                  value={formData.amount}
                  onChange={handleChange}
                  placeholder="Enter amount"
                  required
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label for="roi">ROI (%)</Label>
                <Input
                className="form-control-alternative"
                  type="text"
                  name="roi"
                  id="roi"
                  value={formData.roi}
                  onChange={handleChange}
                  placeholder="Enter ROI"
                  step="0.01"
                  required
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label for="processingFee">Processing Fee</Label>
                <Input
                className="form-control-alternative"
                  type="text"
                  name="processingFee"
                  id="processingFee"
                  value={formData.processingFee}
                  onChange={handleChange}
                  placeholder="Enter fee"
                  step="0.01"
                  required
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label for="tenure">Tenure</Label>
                <Input
                className="form-control-alternative"
                  type="text"
                  name="tenure"
                  id="tenure"
                  value={formData.tenure}
                  onChange={handleChange}
                  placeholder="Enter tenure"
                  required
                />
              </FormGroup>
            </Col>
          </Row>
          <div className="text-end">
            <Button color="primary" type="submit">
              Submit
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default Topup;
